/**
 * GET_MEMBER_PROFILE_FAILURE
 */
function* getMemberProfileFailure({ error }) {
  console.log('Failure', error)
}

export default getMemberProfileFailure
